<template>
   <div class="not-found-box-container" v-if="isTimerActive">
    
        <img class="not-found-icon" src="/icons/general_icons/warning.svg" alt="not.found.icon">

    
    <p class="messages"> {{ responseStatusMessages }} </p> 
   </div>

</template>

<script>
export default {
props:{
  responseStatusMessages:{
      type:String,
      default:''
  },
  timer:{
      type:Number,
      default:0
  }
},
data(){
    return {
        isTimerActive:false
    }
},
created(){
    if(this.timer > 0){
        setTimeout(() => {
            this.isTimerActive = true

        }, this.timer);
    }
    else {
        this.isTimerActive = true;
    }

}
}
</script>

<style scoped lang="scss">

.not-found-box-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: center;
    padding: 1vw;
     gap: 3%;
     border: 1px dotted #e91414d8;
     border-radius: 8px;



}

.not-found-icon {
    height: 2vw;
 width: 2vw;
 



}

.messages {
    width: max-content;
     font-size: .7vw;
     font-weight: 550;
     color: #0d0f27b9;
}
</style>